const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const initialized = new WeakSet();
// Scroll reveal is shared with grand.js; this module owns gallery and filtering only.

function setupCollection(root) {
  const grid = root.querySelector('[data-ud-grid]');
  const cards = [...grid.querySelectorAll('[data-ud-card]')];
  const buttons = [...root.querySelectorAll('[data-ud-filter]')];
  const sort = root.querySelector('[data-ud-sort]');
  if (!sort) return;
  let filter = 'all';
  function update() {
    const ordered = [...cards].sort((a,b) => sort.value === 'original' ? Number(a.dataset.order)-Number(b.dataset.order) : a.dataset.title.localeCompare(b.dataset.title) * (sort.value === 'za' ? -1 : 1));
    let count = 0;
    for (const card of ordered) {
      card.hidden = filter !== 'all' && card.dataset.category !== filter;
      if (!card.hidden) count++;
      grid.append(card);
    }
    root.querySelector('[data-ud-count]').textContent = `${count} ${root.querySelector('[data-ud-count-label]').content.textContent.trim()}`;
    buttons.forEach(button => { const active = button.dataset.udFilter === filter; button.classList.toggle('is-active',active); button.setAttribute('aria-pressed',String(active)); });
  }
  buttons.forEach(button => button.addEventListener('click',() => { filter = button.dataset.udFilter; update(); }));
  sort.addEventListener('change',update);
  root.querySelector('[data-ud-tools]').hidden = false;
  root.addEventListener('shopify:block:select',event => {
    const card = event.target.closest('[data-ud-card]');
    if (card?.hidden) {filter = 'all';update();}
  });
}

function setupDetail(root) {
  const thumbs = [...root.querySelectorAll('[data-ud-thumb]')];
  const panels = [...root.querySelectorAll('[data-ud-panel]')];
  function select(id) {
    panels.forEach(panel => {
      panel.hidden = panel.dataset.udPanel !== id;
      panel.querySelector('[data-ud-zoom]')?.classList.remove('is-zoomed');
      panel.querySelectorAll('video').forEach(video => {
        if (panel.hidden || reduced.matches) video.pause();
        else video.play().catch(() => {});
      });
    });
    thumbs.forEach(button => {
      const active = button.dataset.udThumb === id;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  }
  thumbs.forEach(button => button.addEventListener('click',() => select(button.dataset.udThumb)));
  root.addEventListener('shopify:block:select',event => {
    const panel = event.target.closest('[data-ud-panel]');
    if (panel) select(panel.dataset.udPanel);
  });
  root.querySelectorAll('[data-ud-zoom]').forEach(zoom => {
    function position(event) {
      const rect = zoom.getBoundingClientRect();
      zoom.style.setProperty('--ud-x',`${Math.max(0,Math.min(100,(event.clientX-rect.left)/rect.width*100))}%`);
      zoom.style.setProperty('--ud-y',`${Math.max(0,Math.min(100,(event.clientY-rect.top)/rect.height*100))}%`);
    }
    const stop = () => zoom.classList.remove('is-zoomed');
    zoom.addEventListener('pointerenter',event => {if(event.pointerType==='mouse'){position(event);zoom.classList.add('is-zoomed');}});
    zoom.addEventListener('pointermove',position);
    zoom.addEventListener('pointerdown',event => {position(event);zoom.classList.add('is-zoomed');});
    for(const name of ['pointerup','pointercancel','pointerleave','blur'])zoom.addEventListener(name,stop);
    zoom.addEventListener('keydown',event => {if(event.key==='Enter'||event.key===' '){event.preventDefault();zoom.classList.add('is-zoomed');}if(event.key==='Escape')stop();});
    zoom.addEventListener('keyup',stop);
  });
  if (panels[0]) select(panels[0].dataset.udPanel);
}

function scan(root=document) {
  root.querySelectorAll('[data-ud-collection],[data-ud-detail]').forEach(section => {
    if(initialized.has(section))return;
    initialized.add(section);
    if(section.matches('[data-ud-collection]'))setupCollection(section);
    else setupDetail(section);
  });
}
scan();
document.addEventListener('shopify:section:load',event=>scan(event.target));
reduced.addEventListener('change',()=>{if(reduced.matches)document.querySelectorAll('.ud-detail video').forEach(video=>video.pause());});
document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('.ud-detail video').forEach(video=>video.pause());});
